// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List       = require("bs-platform/lib/js/list.js");
var Js_math    = require("bs-platform/lib/js/js_math.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");

function all(x) {
  var xs = [];
  xs[0] = x;
  xs[1] = xs;
  return xs;
}

function take(n, ls) {
  if (ls && n !== 0) {
    return /* :: */[
            ls[0],
            take(n - 1 | 0, ls[1])
          ];
  } else {
    return /* [] */0;
  }
}

function transpose(ls) {
  if (ls && ls[0]) {
    return /* :: */[
            List.map(List.hd, ls),
            transpose(List.map(List.tl, ls))
          ];
  } else {
    return /* [] */0;
  }
}

function shiftLeft(board) {
  var shiftHelper = function (_ls) {
    while(true) {
      var ls = _ls;
      if (ls) {
        var head = ls[0];
        if (head !== 0) {
          var rest = ls[1];
          if (rest) {
            var next = rest[0];
            if (next !== 0) {
              if (head === next) {
                return /* :: */[
                        head + next | 0,
                        shiftHelper(rest[1])
                      ];
              } else {
                return /* :: */[
                        head,
                        shiftHelper(rest)
                      ];
              }
            } else {
              _ls = /* :: */[
                head,
                rest[1]
              ];
              continue ;
              
            }
          } else {
            return /* :: */[
                    head,
                    shiftHelper(rest)
                  ];
          }
        } else {
          _ls = ls[1];
          continue ;
          
        }
      } else {
        return /* [] */0;
      }
    };
  };
  return List.map((function (ls) {
                var e = 0;
                var n = List.length(ls);
                var ls$1 = shiftHelper(ls);
                return take(n, Pervasives.$at(ls$1, all(e)));
              }), board);
}

function orient(direction, phase, board) {
  switch (direction) {
    case 0 : 
        return board;
    case 1 : 
        return List.map(List.rev, board);
    case 2 : 
        return transpose(board);
    case 3 : 
        if (phase !== 0) {
          return List.rev(transpose(board));
        } else {
          return transpose(List.rev(board));
        }
    
  }
}

function shift(direction, board) {
  return orient(direction, /* Post */1, shiftLeft(orient(direction, /* Pre */0, board)));
}

function randomInt(num) {
  return Js_math.floor_int(Math.random() * num);
}

function addCell(board) {
  var flatBoard = List.flatten(board);
  var numZeros = List.length(List.filter((function (param) {
                return +(0 === param);
              }))(flatBoard));
  if (numZeros !== 0) {
    var newValue = Caml_array.caml_array_get(/* array */[
          2,
          2,
          2,
          2,
          4
        ], randomInt(5));
    var newCellPos = randomInt(numZeros);
    var placeZero = function (zerosFound, fb) {
      var match = +(zerosFound === newCellPos);
      if (fb) {
        var h = fb[0];
        if (h !== 0) {
          return /* :: */[
                  h,
                  placeZero(zerosFound, fb[1])
                ];
        } else {
          var t = fb[1];
          if (match !== 0) {
            return /* :: */[
                    newValue,
                    placeZero(zerosFound + 1 | 0, t)
                  ];
          } else {
            return /* :: */[
                    0,
                    placeZero(zerosFound + 1 | 0, t)
                  ];
          }
        }
      } else {
        return /* [] */0;
      }
    };
    var n = List.length(List.hd(board));
    var list = placeZero(0, flatBoard);
    var helper = function (_i, _acc, _ls) {
      while(true) {
        var ls = _ls;
        var acc = _acc;
        var i = _i;
        if (ls) {
          if (i !== 0) {
            _ls = ls[1];
            _acc = /* :: */[
              ls[0],
              acc
            ];
            _i = i - 1 | 0;
            continue ;
            
          } else {
            return Pervasives.$at(/* :: */[
                        List.rev(acc),
                        /* [] */0
                      ], helper(n, /* [] */0, ls));
          }
        } else {
          return /* :: */[
                  List.rev(acc),
                  /* [] */0
                ];
        }
      };
    };
    return helper(n, /* [] */0, list);
  } else {
    return board;
  }
}

function make() {
  return addCell(addCell(addCell(/* :: */[
                      /* :: */[
                        0,
                        /* :: */[
                          0,
                          /* :: */[
                            0,
                            /* :: */[
                              0,
                              /* [] */0
                            ]
                          ]
                        ]
                      ],
                      /* :: */[
                        /* :: */[
                          0,
                          /* :: */[
                            0,
                            /* :: */[
                              0,
                              /* :: */[
                                0,
                                /* [] */0
                              ]
                            ]
                          ]
                        ],
                        /* :: */[
                          /* :: */[
                            0,
                            /* :: */[
                              0,
                              /* :: */[
                                0,
                                /* :: */[
                                  0,
                                  /* [] */0
                                ]
                              ]
                            ]
                          ],
                          /* :: */[
                            /* :: */[
                              0,
                              /* :: */[
                                0,
                                /* :: */[
                                  0,
                                  /* :: */[
                                    0,
                                    /* [] */0
                                  ]
                                ]
                              ]
                            ],
                            /* [] */0
                          ]
                        ]
                      ]
                    ])));
}

function score(board) {
  return List.fold_left((function (prim, prim$1) {
                return prim + prim$1 | 0;
              }), 0, List.map((function (param) {
                    return List.fold_left((function (prim, prim$1) {
                                  return prim + prim$1 | 0;
                                }), 0, param);
                  }), board));
}

function gameIsOver(board) {
  return List.for_all((function (direction) {
                return List.for_all((function (param) {
                              return +(0 !== param);
                            }), List.flatten(shift(direction, board)));
              }), /* :: */[
              /* Left */0,
              /* :: */[
                /* Up */2,
                /* [] */0
              ]
            ]);
}

exports.shift      = shift;
exports.addCell    = addCell;
exports.make       = make;
exports.score      = score;
exports.gameIsOver = gameIsOver;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./src/lib/gameLogic.re
// module id = 36
// module chunks = 0